import React, { useState } from 'react';
import { adminAPI } from '../services/api';

interface Item {
  _id: string;
  name: string;
  teluguName: string;
  category: string;
  description: string;
  price: number;
  imageUrl: string;
  isAvailable: boolean;
}

interface ItemsManagementProps {
  items: Item[];
  onRefresh: () => void;
}

const ItemsManagement: React.FC<ItemsManagementProps> = ({ items, onRefresh }) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    teluguName: '',
    category: 'Fruits',
    description: '',
    price: 0,
    imageUrl: '',
    isAvailable: true,
  });

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await adminAPI.createItem(formData);
      alert('Item added successfully');
      setShowAddForm(false);
      setFormData({
        name: '',
        teluguName: '',
        category: 'Fruits',
        description: '',
        price: 0,
        imageUrl: '',
        isAvailable: true,
      });
      onRefresh();
    } catch (error) {
      alert('Failed to add item');
    }
  };

  const handleDelete = async (id: string) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await adminAPI.deleteItem(id);
        alert('Item deleted successfully');
        onRefresh();
      } catch (error) {
        alert('Failed to delete item');
      }
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Items Management</h2>
        <button className="add-btn" onClick={() => setShowAddForm(!showAddForm)}>
          {showAddForm ? 'Cancel' : '+ Add New Item'}
        </button>
      </div>

      {showAddForm && (
        <div style={{ background: 'white', padding: '30px', borderRadius: '15px', marginBottom: '20px' }}>
          <h3>Add New Item</h3>
          <form onSubmit={handleAdd} style={{ display: 'grid', gap: '15px', marginTop: '20px' }}>
            <input
              type="text"
              placeholder="Item Name (English)"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            />
            <input
              type="text"
              placeholder="Item Name (Telugu)"
              value={formData.teluguName}
              onChange={(e) => setFormData({ ...formData, teluguName: e.target.value })}
              required
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            />
            <select
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            >
              <option>Fruits</option>
              <option>Vegetables</option>
              <option>Dairy</option>
              <option>Bakery</option>
              <option>Snacks</option>
              <option>Beverages</option>
              <option>Others</option>
            </select>
            <input
              type="text"
              placeholder="Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            />
            <input
              type="number"
              placeholder="Price"
              value={formData.price}
              onChange={(e) => setFormData({ ...formData, price: parseFloat(e.target.value) })}
              required
              step="0.01"
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            />
            <input
              type="text"
              placeholder="Image URL"
              value={formData.imageUrl}
              onChange={(e) => setFormData({ ...formData, imageUrl: e.target.value })}
              style={{ padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
            />
            <button type="submit" className="add-btn" style={{ width: '100%' }}>
              Add Item
            </button>
          </form>
        </div>
      )}

      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Telugu Name</th>
              <th>Category</th>
              <th>Price</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item._id}>
                <td>
                  <img 
                    src={item.imageUrl} 
                    alt={item.name} 
                    style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px' }}
                    onError={(e) => { (e.target as HTMLImageElement).src = 'https://via.placeholder.com/50'; }}
                  />
                </td>
                <td>{item.name}</td>
                <td>{item.teluguName}</td>
                <td>{item.category}</td>
                <td>₹{item.price.toFixed(2)}</td>
                <td>
                  <span className={`status-badge ${item.isAvailable ? 'status-delivered' : 'status-cancelled'}`}>
                    {item.isAvailable ? 'Available' : 'Unavailable'}
                  </span>
                </td>
                <td>
                  <button className="action-btn delete-btn" onClick={() => handleDelete(item._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemsManagement;
